import { BaseModel } from "sjs-base-model";

export default class ExternalAuthenticateRequestModel extends BaseModel {
    //public readonly username: string = "";
    //public readonly password: string = "";
    public readonly member: number | undefined = undefined;
    public readonly abi: string = "";
    public readonly name: string = "";
    public readonly lastName: string = "";
    public readonly email: string = "";
    public readonly tokenCse: string = "";

    constructor(data: Partial<ExternalAuthenticateRequestModel>) {
        super();

        this.update(data);
    }
}
